export enum AntivirusResult {
	CLEAN = 'clean',
}
